<script setup>
import { useRoute, useRouter } from "vue-router";
import { useAuthStore } from "@/store/authStore";
import SidenavItem from "./SidenavItem.vue";

const auth = useAuthStore();
const router = useRouter();
const emit = defineEmits(["close-mobile-sidebar"]);
const handleLogout = () => {
  auth.logout();
  router.push("/signin");
  emit("close-mobile-sidebar");
};

const getRoute = () => {
  const route = useRoute();
  const routeArr = route.path.split("/");
  return routeArr[1];
};
</script>

<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item
          to="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          navText="Panel de Control"
          @close-mobile-sidebar="$emit('close-mobile-sidebar')"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-secondary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/lista-de-agentes"
          :class="getRoute() === 'lista-de-agentes' ? 'active' : ''"
          navText="Lista de Agentes"
          @close-mobile-sidebar="$emit('close-mobile-sidebar')"
        >
          <template v-slot:icon>
            <i class="ni ni-calendar-grid-58 text-secondary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/casas"
          :class="getRoute() === 'casas' ? 'active' : ''"
          navText="Casas"
          @close-mobile-sidebar="$emit('close-mobile-sidebar')"
        >
          <template v-slot:icon>
            <i class="fas fa-building text-secondary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/contacto"
          :class="getRoute() === 'contacto' ? 'active' : ''"
          navText="Contacto"
          @close-mobile-sidebar="$emit('close-mobile-sidebar')"
        >
          <template v-slot:icon>
            <i class="ni ni-send text-secondary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/blogs"
          :class="getRoute() === 'blogs' ? 'active' : ''"
          navText="Blogs"
          @close-mobile-sidebar="$emit('close-mobile-sidebar')"
        >
          <template v-slot:icon>
            <font-awesome-icon icon="fa-solid fa-blog" class="text-secondary text-sm opacity-10" />
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/categorias"
          :class="getRoute() === 'categorias' ? 'active' : ''"
          navText="Categorías"
          @close-mobile-sidebar="$emit('close-mobile-sidebar')"
        >
          <template v-slot:icon>
            <i class="ni ni-bullet-list-67 text-secondary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/amenidades"
          :class="getRoute() === 'amenidades' ? 'active' : ''"
          navText="Amenidades"
          @close-mobile-sidebar="$emit('close-mobile-sidebar')"
        >
          <template v-slot:icon>
            <i class="fas fa-tv text-secondary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/blog-categorias"
          :class="getRoute() === 'blog-categorias' ? 'active' : ''"
          navText="Categoría de Blog"
          @close-mobile-sidebar="$emit('close-mobile-sidebar')"
        >
          <template v-slot:icon>
            <i class="ni ni-tag text-secondary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item">
        <sidenav-item
          to="/suscriptores"
          :class="getRoute() === 'suscriptores' ? 'active' : ''"
          navText="Suscriptores"
          @close-mobile-sidebar="$emit('close-mobile-sidebar')"
        >
          <template v-slot:icon>
            <i class="ni ni-email-83 text-secondary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

   

      <li class="nav-item" @click="handleLogout" style="cursor: pointer">
        <a class="nav-link">
          <div class="icon icon-shape icon-sm text-center me-2 d-flex align-items-center justify-content-center">
            <i class="ni ni-button-power text-danger text-sm opacity-10"></i>
          </div>
          <span class="nav-link-text ms-1">Cerrar Sesión</span>
        </a>
      </li>
    </ul>
  </div>
</template>
